import { DocumentTransform } from '@apollo/client';
import type { ASTVisitor } from 'graphql';
import { BREAK, Kind, visit } from 'graphql';

export const documentTransform: DocumentTransform = new DocumentTransform(
  (doc) => {
    return visit(doc, removeDeferFromMutations);
  },
);

/**
 * Removes `@defer` directives from mutations unless the mutation has a top-level `@defer`.
 */
const removeDeferFromMutations: ASTVisitor = {
  Document(node) {
    const operation = node.definitions.find(
      (def) => def.kind === Kind.OPERATION_DEFINITION,
    );
    if (
      // only applies to mutations
      operation?.operation !== 'mutation' ||
      // a top-level `@defer` explicitly opts the mutation into `@defer`
      operation.selectionSet.selections.some(
        (selection) =>
          (selection.kind === Kind.FRAGMENT_SPREAD ||
            selection.kind === Kind.INLINE_FRAGMENT) &&
          selection.directives?.some((d) => d.name.value === 'defer'),
      )
    ) {
      return BREAK;
    }
  },
  Directive(node) {
    return node.name.value === 'defer' ? null : node;
  },
};
